import Store from './Store';

const ArticleSalesStore = new Store('articles/active/sales/30');

export {ArticleSalesStore};